import * as React from 'react';
import type { SVGProps } from 'react';
const CalenderIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.3333 16.678H12.6666M15.3411 16.678H16.6744M7.33332 16.678H8.66664M11.3333 12.678H12.6666M15.3411 12.678H16.6744M7.33332 12.678H8.66664M4 9.33332H20.0077M16.0077 7.33332V4M8 7.33332V4M6.67437 20H17.3333C18.8103 20 20.0077 18.8026 20.0077 17.3256V8.00773C20.0077 6.53071 18.8103 5.33332 17.3333 5.33332H6.67437C5.19736 5.33332 4 6.53071 4 8.00773V17.3256C4 18.8026 5.19736 20 6.67437 20Z"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default CalenderIcon;
